.modal {
  padding: 0;
}

.iframe {
  border: none;
  height: calc(calc(var(--mirai-ui-space-XXL) * 10) + calc(var(--mirai-ui-space-S) * 2));
  width: 100%;
}
